import { wrap } from 'comlink/dist/esm/comlink.mjs'
import nodeEndpoint from 'comlink/dist/esm/node-adapter.mjs'
import { uistore } from '../store/uistore'

let W
const getWorker = async (ctx = {}) => {
  if (!W) {
    if(typeof window === 'undefined') {
      const Wrk = await import('worker_threads').then(m => new m.Worker('./dist/server/js.worker.js'))
      W = wrap(nodeEndpoint(Wrk))      
    } else {
      W = wrap(new Worker(new URL('../worker/js.worker.js', import.meta.url), {
        name: 'js.worker'
        /* webpackEntryOptions: { filename: "static/[name].[fullhash].js" } */
      }))
    }
  }

  ctx.location = JSON.parse(JSON.stringify(typeof window !== 'undefined' ? window.location : uistore?.router?.location ?? {}))
  //client-build assignment version || dev
  ctx.assignmentVersion =  typeof window !== 'undefined' && (
    Object.keys(window.store.assignmentVersion).length 
    ? window.store.assignmentVersion 
    : store?.currentApp?.toJSON().assignmentVersions?.[store.currentAssignmentVersions[store.currentAppKey]?.['desktop']]
  )
  
  const keys = Object.keys(ctx)
  const vals = Object.values(ctx)
  const w = await new W(keys, ...vals)
  return w
}

const globalVarsObj = {
  _: {
    text: '_',
    trigger: '.',
    // FIXME: do this without having to include all of lodash
    methods: [] //Object.keys(lodash).sort().filter(f => f[0] !== f[0].toUpperCase())
  },
  currency: {
    text: 'currency',
    trigger: '()',
  },
  jmespath: {
    text: 'jmespath',
    trigger: '',
  },
  location: {
    text: 'location',
    trigger: '.',
  },
  assignmentVersion: {
    text: 'assignmentVersion',
    trigger: '',
  },
  moment: {
    text: 'moment',
    trigger: '()',
    // FIXME: do this without having to include all of moment    
    methods: [] // Object.keys(moment).sort().filter(f => f[0] !== f[0].toUpperCase())
  },
  transform: {
    text: 'transform',
    trigger: '',
  },
  xml: {
    text: 'xml',
    trigger: '',
  }
}
const globalVars = Object.keys(globalVarsObj)
export { getWorker, globalVars, globalVarsObj }
